import { Link } from "react-router-dom";
import { photoUrl } from "./JobPhotos";
import { Camera } from "lucide-react";

export default function PhotoStrip({ job }) {
  const photos = job.photos || [];
  if (!photos.length) {
    return <span className="text-xs text-muted-foreground inline-flex items-center gap-1" data-testid={`photo-strip-empty-${job.id}`}><Camera className="w-3.5 h-3.5" /> No photos</span>;
  }
  const shown = [...photos.filter((p) => p.kind === "after"), ...photos.filter((p) => p.kind === "before")].slice(0, 5);
  return (
    <Link to={`/jobs?job=${job.id}`} className="flex items-center gap-1.5 group" data-testid={`photo-strip-${job.id}`}>
      {shown.map((p) => (
        <div key={p.id} className="relative">
          <img src={photoUrl(job.id, p.id)} alt={p.kind} loading="lazy"
            className="w-12 h-12 object-cover rounded-sm border border-border/60 group-hover:border-brand transition-colors" />
          <span className="absolute bottom-0 left-0 right-0 text-[8px] uppercase text-white bg-black/50 text-center">{p.kind}</span>
        </div>
      ))}
      {photos.length > shown.length && <span className="text-xs text-muted-foreground ml-1">+{photos.length - shown.length}</span>}
    </Link>
  );
}
